import '../Common/css/jquery.jqzoom.css';
import '../Common/css/polaris.css';

import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Common/css/common.css';
import 'bootstrap/dist/js/bootstrap';
import 'icheck/icheck';
import 'jquery-ajax-transport-xdomainrequest';
import '../Common/js/jquery.jqzoom-core';
import { services, helpers } from '../Common/js/services';
import './DoorTypeSelection.css';

$(window).on('load', function () {
    loadDoorTypes();

    services.drawSideLinks(0);
    $("#sideLinksModal .close").off("click").on("click", services.clearSideLinksDialog);
    $("#aditionalInformationModal .close").off("click").on("click", services.clearAditionalInformationDialog);

    $('#availableDoorTypes').on('ifChecked', '.red-check', function () {
        $('#availableDoorTypes .red-check').iCheck('uncheck');
        $('#availableDoorTypes .red-check').iCheck('update');
        $('#availableDoorTypes .red-check').attr('data-checked', 'false');
        $('#availableDoorTypes .item-selected').removeClass('item-selected');

        $(this).parents('div.item').addClass('item-selected');
        $(this).attr('data-checked', 'true');

        //set hardware title
        var doorType = $('input[data-checked=true]').parents('div.rangeItem').find('input[type=hidden]').attr('data-doortype');
        helpers.setHardwareTitle(doorType);

        showImage();
    });

    $('.nextBtn').on('click', function () {
        var doorType = $('input[data-checked=true]').parents('div.rangeItem').find('input[type=hidden]').attr('data-doortype');
        var doorSize = $('input[data-checked=true]').parents('div.rangeItem').find('input[type=hidden]').attr('data-assetid');
        window.location = 'GlassSelection.html?dt=' + doorType + '&ds=' + doorSize;
    });

    $('#availableDoorTypes').on('click', '.doorTypeImage', function () {
        $(this).parent().find('.rangeItem:first input.checkbox').iCheck('check');
    });

    $(window).on('orientationchange', function () {
        if (window.orientation == 0) $('[data-target="#myModal"]').attr('data-target', '#myModal-off');
        else $('[data-target="#myModal-off"]').attr('data-target', '#myModal');
    });

    if (window.innerHeight > window.innerWidth) {
        $('[data-target="#myModal"]').attr('data-target', '#myModal-off');
    }
});

function loadDoorTypes() {
    services.getDoorTypes(function (data) {
            var selectedId = $('#availableDoorTypes').find('.checked').attr('data-assetid');
            var selectedName = $('#availableDoorTypes').find('.checked').attr('data-assetName');
            var previousSelection = $.grep(data, function (item) { return item.Name == selectedName; });

            $('#availableDoorTypes').empty();

            for (var i = 0; i < data.length; i++) {
                var frame = $('<div class="col-md-6 col-sm-6 col-xs-6 item"></div>');
                var image = $('<img class="img-responsive doorTypeImage center-block" src="' + services.webAPIUrl + 'content/images/' + data[i].Icon + '" />');
                var group = $('<span style="color: gray">(' + data[i].Group + ')</span>');
                var metadata = $('<input type="hidden" class="doorTypeInfo" data-onlineNumber="' + data[i].OnlineNumber + '" data-storeNumber="' + data[i].StoreNumber + '" data-assetName="' + data[i].Name + '" data-price="' + data[i].Price + '" data-iconPath="' + data[i].Icon + '" data-imagePath="' + data[i].Image + '" data-assetNumber="' + data[i].ProductNumber + '" data-assetDescription="' + data[i].Description + '" data-finishTypeId="' + data[i].FinishType + '" data-assetId="' + data[i].Id + '" data-doorType="' + data[i].DoorType + '"/>');

                frame.append(metadata);
                frame.append(image);
                var name = data[i].Name.replace(" (", "<br />(");
                frame.append('<div class="nameCenter">' + name + '</div>');

                loadRanges(frame, data[i].Id);

                if (data[i].Group != undefined) frame.append(group);
                $('#availableDoorTypes').append(frame);

                if ((previousSelection.length == 0 && (i == 0 || data[i].IsDefault == true)) || (previousSelection.length > 0 && data[i].Name == previousSelection[0].Name)) {
                    frame.addClass('item-selected');
                }
                if (i + 1 == data.length) {
                    frame.addClass('pull-right');
                }
            }
    });
}
function loadRanges(frame, doorTypeId) {
    services.getDoorSizeRanges(doorTypeId, function (data) {
            for (var i = 0; i < data.length; i++) {
                var friendlyName = data[i].FriendlyName;
                var metadata = '<input type="hidden" class="doorSize" data-onlineNumber="' + data[i].OnlineNumber + '" data-storeNumber="' + data[i].StoreNumber + '" data-assetName="' + data[i].Name + '" data-price="' + data[i].Price + '" data-iconPath="' + data[i].Icon + '" data-imagePath="' + data[i].Image + '" data-assetNumber="' + data[i].ProductNumber + '" data-assetDescription="' + data[i].Description + '" data-finishTypeId="' + data[i].FinishType + '" data-assetId="' + data[i].Id + '" data-doorType="' + data[i].DoorType + '"/>';

                frame.append('<div class="rangeItem">' + metadata + '<label><input type="checkbox" class="checkbox red-check sizeRange" /><span class="hidden-xs hidden-lg displayInlineBlock"><br/></span>' + friendlyName + '</label></div>');
            }

            $('.item-selected').find('.doorSize').addClass('checked');
            $('.item-selected').find('.doorTypeInfo' + '').addClass('selectedDoorType');

            setCheckboxStyle();
            makeDefaultSelections();
            // showImage();
    });
}
function setCheckboxStyle() {
    $('#availableDoorTypes .red-check').iCheck({
        checkboxClass: 'icheckbox_polaris',
        radioClass: 'iradio_polaris',
        increaseArea: '-10%' // optional
    });
}
function makeDefaultSelections() {
    $('#availableDoorTypes .item-selected .red-check').iCheck('check');
    $('#availableDoorTypes .item-selected .red-check').attr('data-checked', 'true');
}

function showImage() {
    var selectedDoorType = $('input[data-checked=true]').parents('div.rangeItem').find('input[type=hidden]');

    services.getDoorSize(selectedDoorType.attr('data-assetid'), 1, function (data) {
            clearDrawing();

            drawDoorType(data.Image);
            drawArrow(data.Arrow, data.FriendlyName, data.DoorType);
            //drawZoom();

            if (selectedDoorType.attr('data-doortype') == 4 || selectedDoorType.attr('data-doortype') == 5)
            $('#finalShowerDoor').append($('<p class="PivotDoorNote text-left"><em><strong>Pivot Doors</strong> can be installed as a left or right side opening configuration.</em></p>'));
    });
}
function clearDrawing() {
    $('#finalShowerDoor').empty();
    $('#finalShowerDoorZoom').empty();
}
function drawDoorType(imagePath) {
    var image = $('<img class="img-responsive doorType" style="margin-left: 0px; position: relative; top: 0; left: 0; width:100%;" src="' + services.webAPIUrl + 'content/images/' + imagePath + '" />');
    var zoom = $('<img class="zoom doorType img-responsive" style="position: relative; top: 0; left: 0;" src="' + services.webAPIUrl + 'content/images/' + imagePath + '" />');

    $('#finalShowerDoor').append(image);
    $('#finalShowerDoorZoom').append($('<span class="close" data-dismiss="modal" aria-hidden="true">&times;</span>'));
    $('#finalShowerDoorZoom').append(zoom);
}
function drawArrow(arrowPath, sizeText, doorType) {
    var arrowImage = $('<img class="img-responsive" style="left: -10px;  position: absolute; top: 0; left: 0;" src="' + services.webAPIUrl + 'Content/Images/' + arrowPath + '" />');
    var arrowZoom = $('<img class="zoom img-responsive" style="position: absolute;  top: 25px; left: 5px; max-width:590px;" src="' + services.webAPIUrl + 'content/images/' + arrowPath + '" />');

    $('#finalShowerDoor').append(arrowImage);
    $('#finalShowerDoorZoom').append(arrowZoom);
}
function drawZoom() {
    $('#finalShowerDoor').append($('<div data-toggle="modal" data-target="#myModal" class="col-md-12 text-center zoom-text" style="cursor: pointer;"><span class="glyphicon glyphicon-zoom-in red"></span> Zoom image</div>'));
}


// WEBPACK FOOTER //
// ./UI/DoorTypeSelection.js